import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  create_candidate_skills_data_action,
  delete_candidate_skill_by_id_data_action,
  get_candidate_all_skills_data_action,
  update_candidate_skill_by_id_data_action,
} from "../../../../redux/_actions";
import { showWarningMessage } from "../../../../_uiComponents/ShowMessageSnack";
function useSkillsInformation(props) {
  const [skillsTagsAdded, setSkillsTagsAdded] = useState([]);
  const [searchKeywordString, setSearchKeywordString] = useState("");
  const [searchKeywordsSuggestions, setSearchKeywordsSuggestions] = useState(
    []
  );
  const [skillsListLoading, setSkillsListLoading] = useState(false);
  const dispatch = useDispatch();

  //get data from redux
  const { userSkillsData } = useSelector(
    (state) => state.get_candidate_all_skills_data_reducer
  );
  const { newUserSkillData } = useSelector(
    (state) => state.create_candidate_skills_data_reducer
  );

  useEffect(() => {
    callApi();
  }, []);

  useEffect(() => {
    if (userSkillsData?.data) {
      let data = userSkillsData?.data;
      setSkillsTagsAdded(data);
    }
  }, [userSkillsData]);

  useEffect(() => {
    if (newUserSkillData?.data) {
      let skills = skillsTagsAdded;
      skills.push(newUserSkillData?.data);
      setSkillsTagsAdded(skills);
    }
  }, [newUserSkillData]);

  const callApi = async () => {
    await dispatch(get_candidate_all_skills_data_action());
    setSkillsListLoading(false);
  };

  // delete skills tags
  const onKeywordsTagsDelete = async (tag) => {
    await dispatch(delete_candidate_skill_by_id_data_action(tag.id));
    let skills = skillsTagsAdded.filter((item) => item !== tag);
    setSkillsTagsAdded(skills);
  };

  // add new skills tags
  const onKeywordsTagsAddition = async (tag) => {
    let primarySkills =
      skillsTagsAdded &&
      skillsTagsAdded.filter((item) => item?.is_primary === true);

    let data = {
      skill: tag,
      is_primary: true,
      rating: 1,
    };
    if (
      Array.isArray(primarySkills) &&
      primarySkills && primarySkills.length >= 5) {
      data["is_primary"] = false;
    }
    await dispatch(create_candidate_skills_data_action(data));

    setSearchKeywordString();
    setSearchKeywordsSuggestions([]);
  };

  const onSkillChange = async (value, key, item) => {
    let data = item;
    data[key] = value;
    data["skill"] = item["skill_name"];

    if (key === "is_primary") {
      let primarySkills =
        skillsTagsAdded &&
        skillsTagsAdded.filter((item) => item?.is_primary === true);
      if (primarySkills && primarySkills.length > 5) {
        showWarningMessage("Can not add more than 5 primary skills");
        return;
      }
    }
    setSkillsListLoading(true);
    await dispatch(update_candidate_skill_by_id_data_action(item?.id, data));

    callApi();
  };

  return {
    skillsTagsAdded,
    skillsListLoading,
    searchKeywordsSuggestions,
    onKeywordsTagsAddition,
    onKeywordsTagsDelete,
    onSkillChange,
  };
}
export default useSkillsInformation;
